import { render, staticRenderFns } from "./DocsExamples.vue?vue&type=template&id=ad3bdb96&"
import script from "./DocsExamples.vue?vue&type=script&lang=js&"
export * from "./DocsExamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports